export default "__VITE_ASSET__y_mQ6inv__"